import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import {select, Store} from '@ngrx/store';
import { DeveloperService } from '@app/services/developer/developer.service';
import * as Reducers from '../../../../../store/reducers';
import * as SettingsActions from '../../../../../store/settings/actions';
import { Subscription } from 'rxjs';
import {tap} from 'rxjs/operators';

@Component({
	selector: 'app-menu-right',
	templateUrl: './menu-right.component.html',
	styleUrls: ['./menu-right.component.scss'],
})
export class MenuRightComponent implements OnInit, OnDestroy {
	
	@HostBinding('class.print-hide')
	public readonly printHide = true;

	public showSidebarTemplate: boolean;
	public showSidebarDevelop: boolean;
	public isSidebarAvailable: boolean;

	public isSidebarOpen: boolean;
	public primaryColor: string;
	public demoModeIcon: string;

	public showDocumentationBtn: boolean;
	public showDeveloperSettingsBtn: boolean;
	public showDevTogglingBtn: boolean;
	// public environment = environment;

	private subscription = new Subscription();

	constructor(
		private store: Store<any>,
		private developerService: DeveloperService,
	) {
		this.isSidebarAvailable = true;
		this.setEyeIcon(developerService.isDemoMode);
	}

	ngOnInit(): void {
		this.subscription.add(this.store.pipe(select(Reducers.getSettings)).subscribe(state => {
			this.showSidebarTemplate = state.isSidebarOpen;
			this.showSidebarDevelop = state.isDevSidebarOpen;
			this.isSidebarOpen = this.showSidebarTemplate || this.showSidebarDevelop;
			this.primaryColor = state.primaryColor;
		}));

		this.subscription.add(this.developerService.isDevMode$.pipe(
			tap(isDevMode => this.showDocumentationBtn = isDevMode)
		).subscribe());
		this.subscription.add(this.developerService.isDemoMode$.pipe(
			tap(isDemoMode => {
				this.showDeveloperSettingsBtn = isDemoMode;
				this.setEyeIcon(isDemoMode);
			})
		).subscribe());
		this.subscription.add(this.developerService.hasDemoToggleMode$.pipe(
			tap(allowDemoToggling => this.showDevTogglingBtn = allowDemoToggling)
		).subscribe());
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	closeSideBar(): void {
		this.isSidebarOpen = false;
		this.showSidebarTemplate = false;
		this.showSidebarDevelop = false;

		this.store.dispatch(
			new SettingsActions.SetStateAction({
				isSidebarOpen: false,
				isDevSidebarOpen: false,
			}),
		);
	}

	toggleSidebarTemplate(): void {
		this.isSidebarOpen = !this.isSidebarOpen;
		this.showSidebarTemplate = this.isSidebarOpen;

		this.store.dispatch(
			new SettingsActions.SetStateAction({
				isSidebarOpen: this.showSidebarTemplate,
				isDevSidebarOpen: false,
			}),
		);
	}

	toggleSidebarDevelop(): void {
		this.isSidebarOpen = !this.isSidebarOpen;
		this.showSidebarDevelop = this.isSidebarOpen;

		this.store.dispatch(
			new SettingsActions.SetStateAction({
				isSidebarOpen: false,
				isDevSidebarOpen: this.showSidebarDevelop,
			}),
		);
	}

	setPrimaryColor(e): void {
		const color = e.target ? e.target.value : e;
		const addStyles = () => {
			const styleElement = document.querySelector('#primaryColor');
			if (styleElement) {
				styleElement.remove();
			}
			const body = document.querySelector('body');
			const styleEl = document.createElement('style');
			const css = document.createTextNode(`:root { --kit-color-primary: ${color};}`);
			styleEl.setAttribute('id', 'primaryColor');
			styleEl.appendChild(css);
			body.appendChild(styleEl);
		};
		addStyles();
		this.store.dispatch(
			new SettingsActions.SetStateAction({
				primaryColor: color,
			}),
		);
	}

	toggleDemo(): void {
		this.developerService.isDemoMode = !this.showDeveloperSettingsBtn;
	}

	setEyeIcon(devMode: boolean): void {
		if (devMode) {
			this.demoModeIcon = 'eye';
		}
		else {
			this.demoModeIcon = 'eye-off';
		}
	}

}
